import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';



const base_url = environment.api;

@Injectable({
  providedIn: 'root'
})
export class LogsSessionService {

  constructor(private http:HttpClient) { }

  get locationId(): string {
      return localStorage.getItem('location') || '';
  }

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  get headers() {
    return {
      headers: {
        'x-token': this.token
      }
    }
  }
  postLogs_Sessions(log:any){
    let base = `${base_url}logs_session?locationId=${this.locationId}`;
    return this.http.post(base,log);
  }
 getLogs_Sessions(
  page: number = 1,
  limit: number = 20,
  search: string = ''
) {

  let base = `${base_url}logs_session?locationId=${this.locationId}`;

  const params = {
    page,
    limit,
    search
  };

  return this.http.get(
    base,
    {
      ...this.headers,
      params
    }
  );

}

getLogsGeneral(
  page: number = 1,
  limit: number = 20,
  search: string = ''
) {

  const base = `${base_url}logs?locationId=${this.locationId}`;

  const params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString())
    .set('search', search);

  return this.http.get(
    base,
    {
      ...this.headers,
      params: params
    }
  );
}
getLogsSesions(
  page: number = 1,
  limit: number = 20,
  search: string = ''
) {

  const base = `${base_url}eventos-seguridad`;

  const params = new HttpParams()
    .set('page', page.toString())
    .set('limit', limit.toString())
    .set('search', search);

  return this.http.get(
    base,
    {
      ...this.headers,
      params: params
    }
  );
}
  
  getLogsGeneralRange(from:any,to:any){
    let base = `${base_url}eventosRango/${from}/${to}`;
    return this.http.get(base,this.headers);
  }
  getLogsGeneralAll(){
      let base = `${base_url}eventosAllReport`;
    return this.http.get(base,this.headers);
  }
  getLogsNavegacionRange(from:any,to:any){
    let base = `${base_url}eventosRangoNavegacion/${from}/${to}`;
    return this.http.get(base,this.headers);
  }
  getLogsNavegacionAll() {
  const base = `${base_url}eventosAllReportNavegacion`;

  return this.http.get(base, {
    ...this.headers,
    responseType: 'text'
  });
}

}
